import { createFileRoute } from "@tanstack/react-router";
import type {} from "@tanstack/react-start";
import { GonePage, goneHandler } from "@/lib/seo/gone";

// Retired: ~690 auto-generated "bank x loan-type x modifier" pages.
// Off-topic for a gold/silver rate site and pure scaled content.
export const Route = createFileRoute("/loan-calculator/$")({
  server: { handlers: { GET: goneHandler } },
  component: GonePage,
});
